import { render, staticRenderFns } from "./InternationalProcedure.vue?vue&type=template&id=dc7528ba&"
import script from "./InternationalProcedure.vue?vue&type=script&lang=js&"
export * from "./InternationalProcedure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports